import * as React from 'react';

import classnames from 'classnames';

import {Body} from '../typography/body';

import styles from './connection-info-body.module.css';

type Props = {
    title?: string | null | undefined;
    children: React.ReactNode;
};

export function ConnectionInfoBody(props: Props) {
    return (
        <div className={classnames('flex flex-dir-col gap-8', styles.container)}>
            {props.title && (
                <Body isBold={true} size='small'>
                    {props.title}
                </Body>
            )}
            {props.children}
        </div>
    );
}
